import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    error: "",
    success: "",
    currentUser: null,
    employees: null,
    agreements: null,
};

const AuthSlice = createSlice({
    name: "Auth",
    initialState,
    reducers: {
        setCurrentUser(state, action) {
            state.currentUser = action.payload
        },
        setEmployees(state, action) {
            state.employees = action.payload
        },
        setAgreements(state, action) {
            state.agreements = action.payload
        }
    },
});

export const {
    setCurrentUser,
    setEmployees,
    setAgreements
} = AuthSlice.actions

export default AuthSlice.reducer;